import { useAppSelector } from 'app/hooks';
import { selectRol, selectToken } from 'features/auth';
import { DashboardAdmin } from 'pages/dashboard';
import Principal from 'pages/principal/Principal';
import { UnifiedLoader } from 'components/loader';
import { shallowEqual } from 'react-redux';
import { useEffect, useState } from 'react';

const Inicio = () => {
    const token = useAppSelector((state) => selectToken(state), shallowEqual);
    const idRol = useAppSelector((state) => selectRol(state), shallowEqual);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 300);

        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return <UnifiedLoader fullScreen text="Verificando sesión..." size="lg" />;
    }

    if (token && (idRol === 5 || idRol === 6 || idRol === 7)) {
        return <DashboardAdmin />;
    }

    return <Principal />;
}

export default Inicio;